import { useNavigate } from 'react-router';
import { Box, Button, Tab, TabList, TabPanels, TabPanel, Tabs } from '@chakra-ui/react';
import { ArrowUpIcon } from '@chakra-ui/icons';

import { useGetAuthorizedTabsSelector, useGetCompanyInfoSelector, useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';
import { useTranslation } from 'helpers/languages/translations';
import { useTabNavigate } from 'router/tabsMapper';

import PageHeader from 'layout/pageHeader';
import MUsersViewer from './components/Molecules/MUsersViewer';
import MCompanyGroupViewer from './components/Molecules/MCompanyGroupViewer';
import MInternationalCompanyGroupViewer from './components/Molecules/MInternationalCompanyGroupViewer';

const PATH = 'user-management';
const ID = 'cdm_usermanager';
const NAME = 'page.user';

const UserManagement = () => {
    const { authorizedTabs } = useGetAuthorizedTabsSelector();
    const has_international_company_groups_access = authorizedTabs.includes('cdm_international_company_groups');
    const navigate = useNavigate();
    const translate = useTranslation();
    const companyInfo = useGetCompanyInfoSelector();
    const { tabIndex, setTabIndex } = useTabNavigate('user-management', {
        'international-company-groups': has_international_company_groups_access,
    });


    const userInfo = useGetUserInfoSelector();
    const readonly = !userInfo?.user_groups?.includes(25);

    const renderTabs = () => (
        <Tabs size="sm" isLazy onChange={(index) => setTabIndex(index)} index={tabIndex}>
            <TabList>
                <Tab _focus={{ boxshadow: 'none' }}>{translate('users.tab.title')}</Tab>
                {companyInfo?.has_company_group_allowed && (
                    <Tab _focus={{ boxshadow: 'none' }}>{translate('users.tab.cg')}</Tab>
                )}
                {has_international_company_groups_access && (
                    <Tab _focus={{ boxshadow: 'none' }}>{translate('users.tab.international_company_groups')}</Tab>
                )}
            </TabList>
            <TabPanels>
                <TabPanel px="0">
                    <MUsersViewer readonly={readonly} />
                </TabPanel>
                {companyInfo?.has_company_group_allowed && (
                    <TabPanel px="0">
                        <MCompanyGroupViewer readonly={readonly} />
                    </TabPanel>
                )}
                {has_international_company_groups_access && (
                    <TabPanel px="0">
                        <MInternationalCompanyGroupViewer readonly={readonly} />
                    </TabPanel>
                )}
            </TabPanels>
        </Tabs>
    );

    return (
        <Box>
            <PageHeader icon={{ name: 'user' }} readonly={readonly} pageTitle="Users">
                <Button
                    onClick={() => {
                        navigate('./upload');
                    }}
                    fontSize="14px"
                    h="30px"
                    bg={'white'}
                    variant="outline"
                    isDisabled={readonly}
                    leftIcon={<ArrowUpIcon />}
                >
                    {translate('users.upload.users')}
                </Button>
            </PageHeader>
            <Box px="32px">{renderTabs()}</Box>
        </Box>
    );
};

export { ID, PATH, NAME };
export default UserManagement;
